import React, { useEffect, useState } from "react";

import KeplerGl from "kepler.gl";

import Loading from "../common/loading/Loading.component";
import { Box, Container } from "@mui/material";
import { ReactReduxContext } from "react-redux";
import IncomeMap from "components/cards/income/IncomeMap.component";
import { useTranslation } from "react-i18next";
import { useMemo } from "react";

const MAPBOX_TOKEN =
  "pk.eyJ1IjoiYWJoaWJhbGFuaSIsImEiOiJja2NyZnRzM3gwaml4MzFteDU1ZnM1dGhpIn0.t8SA-yrv7Im74S8pjd5TiQ";

const Kepler = (props) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(true);
  const localeMessages = useMemo(
    () => ({
      en: {
        "layerManager.addData": t("addData"),
        "filterManager.addFilter": t("addFilter"),
        "datasetInfo.rowCount": t("rowCount"),
        "sidebar.panels.filter": t("filters"),
        "layerManager.addLayer": t("addLayer"),
        'placeholder.yAxis': t('Y Axis'),
        'tooltip.animationByWindow': t('Moving Time Window'),
        'placeholder.search': t('Search'),
        'tooltip.play': t('Play'),
        'placeholder.time': t('Y Axis'),
        'tooltip.animationByIncremental': t('Incremental Time Window'),
        'tooltip.pause': t('Pause'),
      },
    }
    ),
    [t]
  );


  useEffect(() => {
    if (!props.isLoading) {
      setLoading(false);
    } else {
      setLoading(true);
    }
  }, [props.isLoading]);

  return loading ? (
    <>
      <Loading />
      <IncomeMap />
    </>
  ) : (
    <ReactReduxContext.Consumer>
      {({ store }) => {
        return (
          <Box sx={{ position: "relative", width: "100%", padding: 0 }}>
            <Container maxWidth={false} style={{ padding: 0 }}>
              <KeplerGl
                store={store}
                width={"100%"}
                mapboxApiAccessToken={MAPBOX_TOKEN}
                localeMessages={localeMessages}
                height={props.height ? props.height : window.innerHeight}
                appName={"Smart City Xplore"}
              //getMapboxRef={_getMapboxRef}
              />
            </Container>
          </Box>
        );
      }}
    </ReactReduxContext.Consumer>
  );
};

export default Kepler;
